import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MotionPreferencesProvider } from './context/MotionPreferencesContext'
import { ThemeProvider } from './context/ThemeContext'
import App from './App'
import './styles/variables.css'
import './styles/globals.css'
import './styles/animations.css'
import './styles/utilities.css'
import './styles/micro-interactions.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <MotionPreferencesProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MotionPreferencesProvider>
    </ThemeProvider>
  </React.StrictMode>,
)